export const GOOGLE_API_REQUIREMENTS = {
  REQUIRED_TYPE: "establishment"
};

export const GOOGLE_API_KEY = () => {
  return process.env.REACT_APP_GOOGLE_API_KEY;
};

export const GOOGLE_API_RETRIES = () => {
  return process.env.GOOGLE_API_RETRIES || 5;
};

export const BUSINESS_INFO_GOOGLE_AUTOCOMPLETE = {
  MODEL: "googleAccountSearch",
  LABELS: {
    addressLabel: "accountAddress",
    businessDetailsLabel: "accountDetails",
    coordinatesLabel: "accountCoordinates"
  }
};

export const OWNER_ADDRESS_GOOGLE_AUTOCOMPLETE = {
  MODEL: "ownerAddressSearch",
  LABELS: {
    addressLabel: "accountAddress",
    coordinatesLabel: "accountCoordinates"
  }
};